import { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import { Carousel } from "@components/carousel";
import { ArrowRight } from "@icons";
import { dangerHTML } from "@utils/danger";

import { ArticleCard } from "./card";

export function EditorialPanel({
  html,
  isLongEditorialVisible,
  setIsLongEditorialVisible,
}) {
  const [isLongForm, setIsLongForm] = useState(true);

  const ref = useRef(null);

  useEffect(() => {
    if (ref.current.clientHeight < 256) {
      setIsLongForm(false);
    }
  }, [ref]);

  return (
    <div>
      <div
        ref={ref}
        className={cn("relative overflow-hidden ", {
          "max-h-64": !isLongEditorialVisible,
        })}
      >
        <article className="c-styles-itin" {...dangerHTML(html)} />
        {isLongForm && !isLongEditorialVisible && (
          <div className="absolute bottom-0 w-full h-20 bg-gradient-to-b from-transparent to-white" />
        )}
      </div>
      {isLongForm && (
        <button
          type="button"
          className="flex flex-wrap items-center gap-2 mt-4 btn-flat text-slate"
          onClick={() => setIsLongEditorialVisible(!isLongEditorialVisible)}
        >
          <span className="font-semibold">
            Read {isLongEditorialVisible ? "less" : "more"}
          </span>
          <ArrowRight className="mt-0.5" />
        </button>
      )}

      <style jsx global>{`
        .c-styles-itin img {
          display: none;
        }
        .c-styles-itin * + * {
          margin-top: 10px;
        }
        .c-styles-itin h1,
        .c-styles-itin h2,
        .c-styles-itin h3,
        .c-styles-itin h4 {
          margin-top: 20px;
          font-size: 20px;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
}

EditorialPanel.propTypes = {
  html: PropTypes.string.isRequired,
  isLongEditorialVisible: PropTypes.bool.isRequired,
  setIsLongEditorialVisible: PropTypes.func.isRequired,
};

export function ArticlePanel({ className = "", articles }) {
  return (
    <article className={className}>
      <Carousel pageSize={3}>
        {articles.map(article => (
          <ArticleCard key={article.esid} type="article" {...article} />
        ))}
      </Carousel>
    </article>
  );
}

ArticlePanel.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
    })
  ).isRequired,
  className: PropTypes.string,
};
